import { createBrowserRouter } from "react-router-dom";
import App from "./App";
import React from 'react';
import Login from "./Auth";
import HomePage from "./Homepage";
import PrivateRoute from "./privateRoute";
import NavBar from "./Navbar";
import Fabric from "./Fabric";
import Checkout from "./Checkout";
import Profile from "./Checkout/profile";
import Presets_main from "./Presets";
import Preset_item from "./Presets/Preset-item";
import Feel_fabric from "./Fabric/Feel";
import Appointment from "./Contact/appointment";
import Measurement from "./Measurements";
import About from "./Contact/About";
import Terms_C from "./Contact/Terms_C";
import Foot from "./footer";
import Payments_page from "./Checkout/Payment/index";
import Order_page from "./Presets/Order_page";
import ReachUs from "./Contact/reachus";
import Register from "./Contact/register";
import AppointmentPage from "./Contact/AppointmentPage";
import QuotationPage from "./Contact/QuotationPage";
import TestKurtaDesign from "./Test/TestKurtaDesign";
import RenderUpload from "./Test/RenderUpload";


const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    children: [
      {
        path: "/",
        element: (
          <>
            <NavBar flag={3} />
            <HomePage />
            <Foot />
          </>
        )
      },
      {
        path: "/profile",
        element: (
          <>
            <NavBar flag={1} />
            <PrivateRoute>
              <Profile />
            </PrivateRoute>
            <Foot />
          </>
        )
      },
      {
        path:"/login",
        element:(
          <>
            <NavBar flag={1} />
            <Login/>
            <Foot />
          </>
        )
      },
      {
        path:"/custom/:category/:id/:process/:info?",
        element:
        <React.Suspense fallback = "Loading...">
              <Fabric/>
              {/* <Foot/> Footer removed for custom page */}
        </React.Suspense>
      },
      {
        path:"/cart/:id?",
        element:
        <React.Suspense fallback = "Loading...">
            <>
                <NavBar flag={1} />
                <Checkout/>
                <Foot />
            </>
        </React.Suspense>
      },
      {
        path:"/products/:cloth?",
        element:
        <React.Suspense fallback = "Loading...">
            <>
                <NavBar flag={1} />
                <Presets_main/>
                <Foot />
            </>
        </React.Suspense>
      },
      {
        path:"/products/:catr/:name/:id/:des?",
        element:
        <React.Suspense fallback = "Loading...">
            <>
                <NavBar flag={1} />
                <Preset_item/>
                <Foot/>
            </>
        </React.Suspense>
      },
      {
        path:"/feel",
        element:
        <React.Suspense fallback = "Loading...">
            <>
                <NavBar flag={1} />
                <Feel_fabric/>
                <Foot />
            </>
        </React.Suspense>
      },
      {
        path:"/reachus/:req?",
        element:
        <React.Suspense fallback = "Loading...">
            <>
                <NavBar flag={1} />
                <ReachUs/>
                <Foot />
            </>
        </React.Suspense>
      },
      {
        path:"/measurement/:name/:info?",
        element:
        <React.Suspense fallback = "Loading...">
            <>
                <NavBar flag={1} />
                <Measurement/>
                <Foot />
            </>
        </React.Suspense>
      },
      {
        path:"/contact",
        element:
        <React.Suspense fallback = "Loading...">
            <>
                <NavBar flag={0} />
                <ReachUs/>
                <Foot />
            </>
        </React.Suspense>
      },
      {
        path:"/about-us",
        element:
        <React.Suspense fallback = "Loading...">
            <>
                <NavBar flag={1} />
                <About/>
                <Foot />
            </>
        </React.Suspense>
      },
      {
        path:"/appointment",
        element:
        <React.Suspense fallback = "Loading...">
            <>
                <NavBar flag={1} />
                <AppointmentPage/>
                <Foot />
            </>
        </React.Suspense>
      },
      {
        path:"/quotation",
        element:
        <React.Suspense fallback = "Loading...">
            <>
                <NavBar flag={1} />
                <QuotationPage/>
                <Foot />
            </>
        </React.Suspense>
      },
      {
        path:"/terms",
        element:
        <React.Suspense fallback = "Loading...">
            <>
                <NavBar flag={1} />
                <Terms_C/>
                <Foot />
            </>
        </React.Suspense>
      },
      {
        path:"/checkout/payment",
        element:
        <React.Suspense fallback = "Loading...">
            <>
                <NavBar flag={1} />
                <Payments_page/>
                <Foot />
            </>
        </React.Suspense>
      },
      {
        path:"/order/:id",
        element:
        <React.Suspense fallback = "Loading...">
            <>
                <NavBar flag={1} />
                <Order_page/>
                <Foot/>
            </>
        </React.Suspense>
      },
      {
        path:"/register",
        element:
        <React.Suspense fallback = "Loading...">
            <>
                <NavBar flag={1} />
                <Register/>
                <Foot/>
            </>
        </React.Suspense>
      },
      {
        path:"/test-kurta",
        element: <TestKurtaDesign />
      }
      ,
      {
        path:"/test-render-upload",
        element:
        <React.Suspense fallback = "Loading...">
            <>
                <NavBar flag={1} />
                <RenderUpload />
                <Foot />
            </>
        </React.Suspense>
      }
      
    ]
  }
]);

export default router;
